<template>
  <vwc-circular-progress
    :id="id"
    :indeterminate="indeterminate"
    :closed="closed"
    :progress="progress"
    :density="density"
    :aria-label="ariaLabel"
  />
</template>

<script>
  import '@vonage/vwc-circular-progress';

  export default {
    name: 'CdSpinner',
    // See description at https://vivid.vonage.com/?path=/story/atoms-circular-progress--default
    props: {
      id: {
        type: String,
        default: null,
      },
      indeterminate: {
        type: Boolean,
        default: true,
      },
      closed: {
        type: Boolean,
        default: false,
      },
      progress: {
        type: Number,
        default: 0,
      },
      density: {
        type: Number,
        default: 1,
      },
      ariaLabel: {
        type: String,
        default: '',
      },
    },
  };
</script>
